// 用户提供的本地 SVG；这里只维护资源，品牌顺序和分组在业务组件中显式组合。
export const PAYMENT_ICON_FILES = {
  paypal: 'footer-paypal.svg',
  visa: 'footer-visa.svg',
  mastercard: 'footer-mastercard.svg',
  maestro: 'footer-maestro.svg',
  amex: 'footer-amex.svg',
  discover: 'footer-discover.svg',
  jcb: 'footer-jcb.svg',
  diners: 'footer-diners.svg',
  klarna: 'footer-klarna.svg',
  afterpay: 'footer-afterpay.svg',
  frPaypal: 'footer-fr-paypal.svg',
  frCb: 'footer-fr-cb.svg',
  frMastercard: 'footer-fr-mastercard.svg',
  frMaestro: 'footer-fr-maestro.svg',
  frAmex: 'footer-fr-amex.svg',
  frDiscover: 'footer-fr-discover.svg',
  frDiners: 'footer-fr-diners.svg',
  frKlarna: 'footer-fr-klarna.svg',
} as const;

export type PaymentIconName = keyof typeof PAYMENT_ICON_FILES;
